import { useState, useEffect } from "react";
import CustomModal from "../../commons/modals/CustomModal"
import { Button } from "@progress/kendo-react-buttons";
import { clone, formatUpdateProduitBody } from "../../commons/helpers/ObjectHelper";
import { useUpdateProduitMutation } from "../../redux/api/cache";


interface ImageReorderModalProps {
    item: any;
    setShowImageReorder: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function ImageReorderModal(props: ImageReorderModalProps) {
    const [updateProduit] = useUpdateProduitMutation();

    const getOrderedImages = () => {
        const tempDocuments = clone(props.item.documents).filter((d: any) => d.role === "image").sort((a: any, b: any) => a.sequence - b.sequence);

        for (let i = 0; i < tempDocuments.length; i++) {
            const sequence = i + 1;
            if (tempDocuments[i].sequence !== sequence) {
                tempDocuments[i].sequence = sequence;
            }
        }

        return tempDocuments;
    };
    const [orderedImages, setOrderedImages] = useState<any[]>(props.item.documents ? getOrderedImages() : []);
    const [formModified, setFormModified] = useState(false);

    useEffect(() => {
        if (props.item.documents) {
            setOrderedImages(getOrderedImages());
        }
    }, [props.item.documents])


    const handleOnDrop = (e: React.DragEvent<HTMLDivElement>, item: any) => {
        const imageInitiale = JSON.parse(e.dataTransfer.getData("image"))
        const imageFinale = clone(item);
        const indexInitial = imageInitiale.sequence;
        const indexFinal = imageFinale.sequence;
        if (indexInitial !== indexFinal) {
            const tempImages = clone(orderedImages);
            tempImages.find((t: any) => t.referenceId === imageInitiale.referenceId).sequence = indexFinal;
            tempImages.find((t: any) => t.referenceId === imageFinale.referenceId).sequence = indexInitial;
            tempImages.sort((a: any, b: any) => a.sequence - b.sequence);
            setOrderedImages(tempImages);
            setFormModified(true);
        }
    }

    const handleAppliquer = async () => {
        const documents = [...orderedImages, ...props.item.documents.filter((d: any) => d.role !== "image")];
        props.setShowImageReorder(false);
        await updateProduit(formatUpdateProduitBody({ ...props.item, documents: documents }));
    };

    return <CustomModal title="Réordonner les images" body={<>
        <div style={{ display: 'flex', gap: '50px', flexWrap: "wrap", overflow: 'auto' }}>
            {orderedImages.filter((d: any) => d.role === "image").map((d: any, i: number) =>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} onDragStart={(e) => e.dataTransfer.setData("image", JSON.stringify(d))} onDrop={(e) => handleOnDrop(e, d)} onDragOver={(e) => { e.preventDefault(); e.dataTransfer.dropEffect = "copy"; }} key={i}>
                    <img key={i} alt="Non disponible" height={230} width={230} src={props.item.approuve_web ? d.uriCdn : d.uriInterne} style={{ cursor: 'grab' }} />
                    <p>{`Image ${d.sequence}`}</p>
                </div>)}
        </div>
        {formModified && (<div style={{ display: 'flex', justifyContent: 'center', gap: '30px', height: '30px' }}><Button className="blueButton" onClick={handleAppliquer}>Appliquer</Button><Button className="blueButton" onClick={() => { props.setShowImageReorder(false); setFormModified(false); }}>Annuler</Button></div>)}
    </>
    } onClose={() => props.setShowImageReorder(false)} height={"80vh"} width={"80vw"} />
}